var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipeNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662543139491,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 75075,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M632 112c66.3 0 120 53.7 120 120v446.7L690.8 912H232c-66.3 0-120-53.7-120-120V232c0-66.3 53.7-120 120-120h400zM530 638H266c-37.6 0-68 30.4-68 68s30.4 68 68 68h264c37.6 0 68-30.4 68-68s-30.4-68-68-68z m-12-200H266c-37.6 0-68 30.4-68 68s30.4 68 68 68h252c37.6 0 68-30.4 68-68s-30.4-68-68-68zM370 238H266c-37.6 0-68 30.4-68 68s30.4 68 68 68h104c37.6 0 68-30.4 68-68s-30.4-68-68-68z",
    fill: "#ffffff",
    "p-id": 75076
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M717 946H232c-84.9 0-154-69.1-154-154V232c0-84.9 69.1-154 154-154h400c84.9 0 154 69.1 154 154v451.1L717 946zM232 146c-47.4 0-86 38.6-86 86v560c0 47.4 38.6 86 86 86h432.6L718 674.3V232c0-47.4-38.6-86-86-86H232z m298 662H266c-56.2 0-102-45.8-102-102 0-49.3 35.2-90.6 81.8-100-46.6-9.4-81.8-50.7-81.8-100s35.2-90.6 81.8-100c-46.6-9.4-81.8-50.7-81.8-100 0-56.2 45.8-102 102-102h104c56.2 0 102 45.8 102 102 0 46.4-31.2 85.7-73.7 98H518c56.2 0 102 45.8 102 102 0 47.5-32.7 87.6-76.8 98.9 50 6.5 88.8 49.4 88.8 101.1 0 56.2-45.8 102-102 102zM266 672c-18.7 0-34 15.3-34 34s15.3 34 34 34h264c18.7 0 34-15.3 34-34s-15.3-34-34-34H266z m0-200c-18.7 0-34 15.3-34 34s15.3 34 34 34h252c18.7 0 34-15.3 34-34s-15.3-34-34-34H266z m0-200c-18.7 0-34 15.3-34 34s15.3 34 34 34h104c18.7 0 34-15.3 34-34s-15.3-34-34-34H266z",
    fill: "#ffffff",
    "p-id": 75077
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M591.9 878.1h235v68h-235z",
    fill: "#ffffff",
    "p-id": 75078
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M831.8 946.2c-62.9 0-114-51.1-114-114v-194h154c40.8 0 74 33.2 74 74v120c0 62.8-51.1 114-114 114z m-46-240v126c0 25.4 20.6 46 46 46s46-20.6 46-46v-120c0-3.3-2.7-6-6-6h-86z",
    fill: "#ffffff",
    "p-id": 75079
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeNum);
export default __webpack_public_path__ + "static/media/recipeNum.c8c46c2f.svg";
export { ForwardRef as ReactComponent };